<template>
    <div>
        <div class="foot">
            <ul class="clearfix">
                <li class="footMessage" @click="messageMask"><van-icon name="gold-coin">5秒询价</van-icon></li>
                <li class="footTelphone" @click="phone"><van-icon name="phone">{{publicData.ContactInfo[0].Phone}}</van-icon></li>
            </ul>
        </div>
        <c_Mask v-if="footMask"></c_Mask>
        <c_LeaveMessage v-if="message" v-on:lmClose="lvMessage" :public-data="publicData"></c_LeaveMessage>
        <c_CallUp v-if="call" @footCall="callUp" :public-data="publicData"></c_CallUp>
    </div>
</template>

<script>
    import c_Mask from '@/components/Mask/Mask'
    import c_LeaveMessage from '@/components/LeaveMessage/LeaveMessage'
    import c_CallUp from '@/components/CallUp/CallUp'
    export default {
        name: 'Foot',
        props:['publicData'],
        components:{c_Mask,c_LeaveMessage,c_CallUp},
        data () {
            return {
              footMask:false,
              message:false,
              call:false
            }
        },
      methods:{
        messageMask(){
          this.message = !this.message;
          this.footMask = true;
        },
        phone(){
          // this.call = !this.call;
          // this.footMask = true;
            this.axios.post('http://travel.xiangbaoche.cn/api.php/api/Gbook/create_action_count',{site:4,type:1}).then(function (res) {
                console.log(res);
            }).catch(function (err) {
                console.log(err);
            });
            window.location.href = 'tel:'+this.publicData.ContactInfo[0].Phone;
        },
        lvMessage(val){
          this.message = val;
          this.footMask = false
        },
        callUp(val){
          this.call = val;
          this.footMask = false;

        }
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clear {
        overflow: hidden;
    }

    .clearfix:before, .clearfix:after {
        clear: both;
        content: " ";
        display: table;
    }
    .foot{height: 80px;line-height: 80px;position: fixed;left: 0;bottom: 20px;width: 100%;text-align: center;}
    .foot li i{display:inline-block;float:none;height: 80px;margin: 0;font-size:32px;font-weight:500;}
    .foot li i:before{font-size: 50px;margin-right: 10px;position: relative;top: 12px;}
    .footMessage{width: calc(50% - 15px);float: left;background:rgba(29,210,175,1);box-shadow:0px 2px 0px 0px rgba(0,0,0,0.1);font-size:32px;
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(255,255,255,1);margin: 10px 5px 10px 10px;border-radius: 60px;-webkit-border-radius: 60px;-moz-border-radius: 60px;}
    .footTelphone{width: calc(50% - 15px);float: left;background:rgba(44,62,80,1);
      box-shadow:0px 2px 0px 0px rgba(0,0,0,0.1);font-size:32px;
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(29,210,175,1);margin: 10px 5px 10px 10px;border-radius: 60px;-webkit-border-radius: 60px;-moz-border-radius: 60px;}
</style>



// WEBPACK FOOTER //
// src/components/Foot/Foot.vue